// extracted by mini-css-extract-plugin
export var printerCard = "_hy-1";
export var printerCardConfigured = "_hy-2";
export var printerCardError = "_hy-3";
export var printerCardsContainer = "_hy-0";
export var printerIcon = "_hy-8";
export var printerIconConfigured = "_hy-5";
export var printerIconContainer = "_hy-4";
export var printerIconError = "_hy-6";
export var printerIconUnconfigured = "_hy-7";
export var workstationsTableCard = "_hy-9";